import { BackupService } from './../../core/services/backup.service';
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
//import { ToasterService } from "angular2-toaster";
import { ConfigurationService } from "../../core/services/configuration.service";
import { SettingsService } from "../../core/settings/settings.service";
import { UtilsService } from '../../core/services/utils.service';

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
})
export class LayoutComponent implements OnInit {
  processing = {
    configurationFile: false,
  };

  constructor(
    private settings: SettingsService,
    private router: Router,
    private configurationService: ConfigurationService,
    //public toasterService: ToasterService,
    private backupService: BackupService,
    private utilsService: UtilsService
  ) {
    // Check token data
    if (localStorage.getItem("token") === null) {
      this.utilsService.sessionExpired();
      this.router.navigate(["/login"]);
    } else {
      this.loadConfigurationFile();
      this.setupBackup();
    }
  }

  ngOnInit() {
  }

  loadConfigurationFile(): void {
    this.processing.configurationFile = true;
    this.configurationService.loadConfigurationFile().subscribe(
      (response) => {
        const { data } = response;
        this.processing.configurationFile = false;
        this.configurationService.setConfigurationFile(JSON.parse(data));
      },
      (error) => {
        // this.toasterService.pop("error", "load config file err", this.settings.manageErrorMsg(error));
      }
    );
  }

  setupBackup(): void {
    this.backupService.setupLocalStorage();
  }
}
